import { useSplitTreatments } from '@splitsoftware/splitio-react'
import FEATURE_FLAGS from '~/consts/featureFlags'
import USERS from '~/consts/users'
import type { FeatureFlag } from '~/types/app'
import type { TechDiscUser } from '~/types/user'

export default function useFeatureFlags(user: TechDiscUser | null | undefined) {
    const { treatments } = useSplitTreatments({ names: Object.keys(FEATURE_FLAGS) })

    return Object.entries(treatments).reduce(
        (acc, [flag, treatment]) => {
            acc[flag as FeatureFlag] = [
                'on',
                user?.roles?.includes(USERS.ROLES.BETA_USER) && 'beta',
                user?.roles?.includes(USERS.ROLES.ADMIN) && 'admin',
                user?.roles?.includes(USERS.ROLES.STORE) && 'store',
                user?.roles?.includes(USERS.ROLES.EARLY_ACCESS_USER) && 'early-access',
                user?.roles?.includes(USERS.ROLES.PREMIUM_STORE) && 'store+',
            ].includes(treatment.treatment)
            return acc
        },
        {} as Record<FeatureFlag, boolean>,
    )
}
